import { reportUsage, reportUsageNow } from '@ms/yammer-telemetry';

import { EcsConfig, EcsProjectTeamName, Experiment, ExperimentTreatmentValue } from '../state/types';

export type ReportEcsEtagMapping = (etag: EcsConfig['etag'], configIds: EcsConfig['configIds']) => void;
export const reportEcsEtagMapping: ReportEcsEtagMapping = (etag, configIds) => {
  reportUsage({
    eventName: 'ecs_etag_mapping',
    eventProperties: {
      ConfigIDs: JSON.stringify(configIds),
      ETag: etag,
    },
  });
};

const reportedExperimentKeys: Partial<Record<Experiment, true>> = {};

export type ReportEcsExperimentTreatment = (
  id: Experiment,
  treatment: ExperimentTreatmentValue,
  projectTeam: EcsProjectTeamName,
  etag: string | undefined
) => void;
export const reportEcsExperimentTreatment: ReportEcsExperimentTreatment = (id, treatment, projectTeam, etag) => {
  if (reportedExperimentKeys[id]) {
    return;
  }

  reportedExperimentKeys[id] = true;

  reportUsage({
    eventName: 'ecs_experiment_treatment',
    eventProperties: {
      ProjectTeam: projectTeam,
      TreatmentKey: id,
      TreatmentValue: treatment,
      ETag: etag,
    },
  });
};

export type ReportEcsExperimentTreatmentNow = (
  id: Experiment,
  treatment: ExperimentTreatmentValue,
  projectTeam: EcsProjectTeamName,
  etag: string | undefined
) => void;
export const reportEcsExperimentTreatmentNow: ReportEcsExperimentTreatmentNow = (id, treatment, projectTeam, etag) => {
  if (reportedExperimentKeys[id]) {
    return;
  }

  reportedExperimentKeys[id] = true;

  reportUsageNow({
    eventName: 'ecs_experiment_treatment',
    eventProperties: {
      ProjectTeam: projectTeam,
      TreatmentKey: id,
      TreatmentValue: treatment,
      ETag: etag,
    },
  });
};
